<script setup lang="ts">
import { getImageUrl } from '@/components/common/common'
import ContentView from './ContentView.vue'
import SalesRepContactButton from '@/components/common/SalesRepContactButton.vue'
import VidacorpLogo from '@/components/icons/VidacorpLogo.vue'

import { useThemeStore } from '@/stores'

interface PromoItem {
  imageUrl: string
  link?: string
  color?: string
}

const promoData: PromoItem[] = [
  {
    imageUrl: 'McoBeauty.jpg',
    color: '#eea6b1'
  },
  {
    imageUrl: 'MyAura.jpg'
  },
  {
    imageUrl: 'BrutalTruth.jpg'
  },
  {
    imageUrl: 'NudeByNature.jpg',
    color: '#c3977d'
  }
]

const themeStore = useThemeStore()
const { themeColors } = themeStore
</script>

<template>
  <ContentView>
    <template #top>
      <VidacorpLogo width="10.9375rem" height="3.125rem" :fill="themeColors.colorText" />
      <SalesRepContactButton label="Contact your VidaCorp Rep" type="vidacorp" />
    </template>
    <template #middle>
      <div class="offers-outer">
        <div
          class="promo"
          v-for="(item, index) in promoData"
          :key="index"
          :class="`container-${index + 1}`"
          :style="`--color-${index + 1}: ${item.color}`"
        >
          <img :src="getImageUrl(item.imageUrl)" :alt="item.imageUrl" />
        </div>
      </div>
    </template>
  </ContentView>
</template>

<style scoped>
.offers-outer {
  /* padding-block: 2.5%; */
  padding-top: 1%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas:
    'promo-one promo-one promo-two promo-three'
    'promo-one promo-one promo-two promo-three'
    'promo-one promo-one promo-four promo-four';
  height: 100%;
  width: 100%;
  gap: 1.5625rem;
  max-height: 83vh;
  align-self: center;
}

.promo {
  transition: background-color 0.5s ease;
  cursor: pointer;
}

.promo.container-1 {
  grid-area: promo-one;
  position: relative;
  min-height: 25rem;
}

.promo.container-2 {
  grid-area: promo-two;
}

.promo.container-3 {
  grid-area: promo-three;
}

.promo.container-4 {
  grid-area: promo-four;
  position: relative;
}

.promo.container-1:after {
  content: '';
  width: 65%;
  aspect-ratio: 1;
  background-color: var(--color-1);
  position: absolute;
  top: -7.5%;
  left: -12.5%;
  z-index: -1;
  border-radius: 50%;
  filter: blur(2.5rem);
  opacity: 0.65;
}

.promo.container-4:after {
  content: '';
  width: 40%;
  aspect-ratio: 1;
  background-color: var(--color-4);
  position: absolute;
  bottom: -12.5%;
  right: -7.5%;
  z-index: -1;
  border-radius: 50%;
  filter: blur(2.5rem);
  opacity: 0.65;
}

.promo img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 93.75rem;
  background: var(--color-background-bright);
}

.promo.container-1 img {
  border-radius: 9.375rem;
}
</style>
